import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

function IntegrationCard({ color, icon, title, description, buttonText, buttonColor, onButtonClick }) {
  return (
    <Card>
      <SoftBox p={2} mx={3} display="flex" justifyContent="center">
        <SoftBox
          display="grid"
          justifyContent="center"
          alignItems="center"
          bgColor={color}
          color="white"
          width="4rem"
          height="4rem"
          shadow="md"
          borderRadius="lg"
          variant="gradient"
        >
          <Icon fontSize="default">{icon}</Icon>
        </SoftBox>
      </SoftBox>

      <SoftBox pb={2} px={2} textAlign="center" lineHeight={1.25}>
        <SoftTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          {title}
        </SoftTypography>

        {description && (
          <SoftTypography variant="caption" color="text" fontWeight="regular">
            {description}
          </SoftTypography>
        )}

        {description && !buttonText ? null : <Divider />}

        {buttonText && (
          <SoftBox mt={2}>
            <SoftButton
              variant="outlined"
              color={buttonColor}
              onClick={onButtonClick}
              fullWidth
            >
              {buttonText}
            </SoftButton>
          </SoftBox>
        )}
      </SoftBox>
    </Card>
  );
}

// Default props
IntegrationCard.defaultProps = {
  color: "info",
  buttonText: "",
  buttonColor: "primary",
  description: "",
  onButtonClick: () => {},
};

// Prop types
IntegrationCard.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  buttonColor: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  onButtonClick: PropTypes.func,
};

export default IntegrationCard;
